import React from 'react';
import PropTypes from 'prop-types';

import VacancyCard from 'components/VacancyCard';

import './FeatureArticleVacancyBlock.scss';

import cn from 'classnames';

const FeatureArticleVacancyBlock = ({
    inRichText,
    ...rest
}) => (
    <div 
        className={cn("feature-article-vacancy-block", {
            ["feature-article-vacancy-block_in-rich-text"]: inRichText
        })}
    >
        <VacancyCard 
            {...rest} 
        />
    </div>
);

FeatureArticleVacancyBlock.propTypes = {
    ...VacancyCard.propTypes,
    inRichText: PropTypes.bool
};

export default FeatureArticleVacancyBlock;



// WEBPACK FOOTER //
// ./src/components/FeatureArticleVacancyBlock/FeatureArticleVacancyBlock.jsx